import 'bootstrap/js/dist/carousel';
import './polyfills';
import * as React from "react";
import * as ReactDOM from "react-dom";
import './style/style.scss';
import LoanForm from "./components/application-form/LoanForm";
import { Provider } from "react-redux";
import ApplicationResponse from './components/application-response';
import { gotoStep, setAmount, setAmountStatic, setStep2Alt } from './store/application/applicationActions';
import store from "./store";

import "./navigation";
import { Step } from './store/application/applicationState';
//import "./backToForm"

import { sentryInit } from './sentryconfig';

sentryInit()

const applicationFormElements = document.getElementsByTagName("application-form");
if (applicationFormElements.length > 0) {
    const element = applicationFormElements[0];
    
    const loanAmount = element.getAttribute("data-loanAmount");
    if (loanAmount) {
        store.dispatch(setAmountStatic(parseInt(loanAmount)));
    }
  
    const step2AltLink = element.getAttribute("data-step2AltLink");
    const step2AltText = element.getAttribute("data-step2AltText");
    if (step2AltLink && step2AltText) {
        store.dispatch(setStep2Alt(step2AltLink, step2AltText));
    }
    ReactDOM.render(
        <Provider store={store}>
            <LoanForm />
        </Provider>,
        element
    );
}

const applicationResponseElements = document.getElementsByTagName("application-response");
if (applicationResponseElements.length > 0) {
    const element = applicationResponseElements[0];
    const referenceId = parseInt(element.getAttribute("data-referenceId"));
    ReactDOM.render(
        <ApplicationResponse referenceId={referenceId} />,
        element
    );
}

